module.exports = __webpack_public_path__ + "img/cholesterol_meter_black.ebfddc68.svg";